import { NOTIFICATION_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

const API_V1 = `${NOTIFICATION_SERVICE_BASE_URL}/api/v1`;
const MOBILE_RECIPIENT_APP = "OLITASK_MOBILE_UI";

const normalizeCategory = (category) => {
  const normalized = String(category || "ACTIVITY").toUpperCase();
  return ["ACTIVITY", "EMAIL", "CHAT"].includes(normalized) ? normalized : "ACTIVITY";
};

export const fetchNotificationsByApp = async ({
  userId,
  category = "ACTIVITY",
  targetRole,
  page = 0,
  size = 20,
  workspaceId,
} = {}) => {
  if (!userId) return [];
  if (!workspaceId) return [];

  const params = new URLSearchParams({
    recipientId: userId,
    recipientApp: MOBILE_RECIPIENT_APP,
    page: String(page),
    size: String(size),
    category: normalizeCategory(category),
    workspaceId,
  });

  if (targetRole) params.append("tar", targetRole);

  const response = await apiClient.get(`${API_V1}/notifications/user/app?${params.toString()}`);
  if (Array.isArray(response.data)) return response.data;
  return response.data?.content || [];
};

export const fetchAllNotifications = async ({
  userId,
  targetRole,
  page = 0,
  size = 20,
  workspaceId,
} = {}) => {
  if (!userId) return [];
  if (!workspaceId) return [];

  const params = new URLSearchParams({
    recipientId: userId,
    recipientApp: MOBILE_RECIPIENT_APP,
    page: String(page),
    size: String(size),
    workspaceId,
  });

  if (targetRole) params.append("tar", targetRole);

  const response = await apiClient.get(`${API_V1}/notifications/user/app?${params.toString()}`);
  if (Array.isArray(response.data)) return response.data;
  return response.data?.content || [];
};

export const fetchUnreadNotificationCount = async ({
  userId,
  category = "ACTIVITY",
  status = "CREATED",
  targetRole,
  workspaceId,
} = {}) => {
  if (!userId || !workspaceId) return 0;

  const params = new URLSearchParams({
    recipientId: userId,
    recipientApp: MOBILE_RECIPIENT_APP,
    category: normalizeCategory(category),
    status,
    workspaceId,
  });

  if (targetRole) params.append("tar", targetRole);

  const response = await apiClient.get(`${API_V1}/notifications/user/app/count?${params.toString()}`);
  return Number(response.data?.count || 0);
};

export const markNotificationsAsRead = async ({
  notificationIds = [],
  status = "READ",
  workspaceId,
} = {}) => {
  if (!notificationIds.length || !workspaceId) return null;

  const params = new URLSearchParams({ workspaceId });
  const response = await apiClient.put(
    `${API_V1}/notifications/bulk-update/status?${params.toString()}`,
    {
      status,
      notificationIds,
    },
  );
  return response.data;
};

export default {
  fetchAllNotifications,
  fetchNotificationsByApp,
  fetchUnreadNotificationCount,
  markNotificationsAsRead,
};
